import { render } from "./SignageLayoutPreview.vue?vue&type=template&id=23608655&scoped=true&ts=true"
import script from "./SignageLayoutPreview.vue?vue&type=script&lang=ts"
export * from "./SignageLayoutPreview.vue?vue&type=script&lang=ts"

import "./SignageLayoutPreview.vue?vue&type=style&index=0&id=23608655&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23608655"]])

export default __exports__